export default "<app-source-select></app-source-select>\n\n<app-crtt-config></app-crtt-config>\n\n<router-outlet></router-outlet>\n";